import { render } from "./OTPModal.vue?vue&type=template&id=8bee82f6"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"

import "./OTPModal.vue?vue&type=style&index=0&id=8bee82f6&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__